import DocumentationButton from "components/DocumentationButton";
import { EmptystateChartColored } from "components/icons/generated";
import Box from "ds/components/Box";
import LinkButton from "ds/components/Button/LinkButton";
import EmptyState from "ds/components/EmptyState";
import TileWrapper from "ds/components/Tile/Wrapper";
import { AnalyticsPageDashboard } from "hooks/useAnalytics/pages/dashboard";
import { getDocsUrl } from "utils/getDocsUrl";
import useCanCreateStack from "shared/Stack/access/useCanCreateStack";
import Tooltip from "ds/components/Tooltip";

import { Widget } from "../../types";

type DashboardWidgetsStackFailuresEmptyProps = {
  notEnoughData?: boolean;
};

const DashboardWidgetsStackFailuresEmpty = ({
  notEnoughData,
}: DashboardWidgetsStackFailuresEmptyProps) => {
  const canCreateStack = useCanCreateStack();
  return (
    <TileWrapper>
      <Box padding="small" fullWidth justify="center">
        <EmptyState
          title="There's no data to show yet"
          icon={EmptystateChartColored}
          caption={
            notEnoughData
              ? "Create more stacks so we can display statistics over stack failures here."
              : "Start creating stacks so we can display statistics over stack failures here."
          }
        >
          <Box gap="medium">
            <DocumentationButton
              to={getDocsUrl("/concepts/stack")}
              label="Documentation"
              analyticsPage={AnalyticsPageDashboard.Dashboard}
              analyticsTitle="Widget - Documentation Clicked"
              analyticsProps={{ widget: Widget.StacksFailures }}
            />
            <Tooltip
              active={!!canCreateStack.message}
              on={(tooltipProps) => (
                <LinkButton
                  {...tooltipProps}
                  variant="primary"
                  to="/new/stack"
                  disabled={!canCreateStack.result}
                >
                  Create stack
                </LinkButton>
              )}
            >
              {canCreateStack.message}
            </Tooltip>
          </Box>
        </EmptyState>
      </Box>
    </TileWrapper>
  );
};

export default DashboardWidgetsStackFailuresEmpty;
